import React from 'react';
import KriterionLogo from './kriterion-logo.svg';

function Logo() {
    return (
        <div className='mainLogo'>
            <meta name="robots" content="noindex, nofollow"></meta>
            <img src={KriterionLogo} alt='Kriterion Logo'/>
        </div>      
    );
}

export default Logo;